"use client"

import { ArrowUpFromLine } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowUpFromLineIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowUpFromLineIcon = component(Icon)({ as: ArrowUpFromLine })
